import { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { motion } from 'framer-motion';
import { clientConfig } from "../../awsClientConfig";
import { GetReferralSummary } from "../../queries/GetReferralSummary";
import { userProfileData } from "../../Common/profileInfo";
import { formatPrice } from "../../functions/misc";

type Summary = {
    activeCount: number | null;
    inactiveCount: number | null;
    nextPayoutAmount: number | null;
    nextPayoutDate: string;
    partnerId: string;
    pendingCount: number | null;
    totalCommissionEarned: number | null;
};

export default function CommissionEarned(this: any) {

    const client = new clientConfig();

    const [summary, setSummary] = useState<Summary>({
        activeCount: null,
        inactiveCount: null,
        nextPayoutAmount: null,
        nextPayoutDate: "",
        partnerId: "",
        pendingCount: null,
        totalCommissionEarned: null,
    });

    const motionItem = {
        initial: { opacity: 0 },
        animate: { opacity: 1, transition: { ease: "easeInOut" } },
    };

    const getSummary = async () => {
        const partnerId = await userProfileData();
        client
            .query({
                query: GetReferralSummary,
                variables: { partnerId: partnerId },
            })
            .then((res: any) => {
                setSummary({
                    activeCount: res.data.GetReferralSummary.ActiveCount,
                    inactiveCount: res.data.GetReferralSummary.InactiveCount,
                    nextPayoutAmount: res.data.GetReferralSummary.NextPayoutAmount,
                    nextPayoutDate: res.data.GetReferralSummary.NextPayoutDate,
                    partnerId: res.data.GetReferralSummary.PartnerId,
                    pendingCount: res.data.GetReferralSummary.PendingCount,
                    totalCommissionEarned: res.data.GetReferralSummary.TotalCommissionEarned
                });
            });
    };

    useEffect(() => {
        getSummary();
    }, []);

    return (
        <section className="commisionEarned">
            <Card className="border-0 w-100">
                <Card.Header>
                    <h6 className="mt-3 ff-Montserrat fs-6">
                        Commission Earned This Period
                    </h6>
                </Card.Header>
                <Card.Body>
                    {typeof (summary.nextPayoutAmount) === "number" ? 
                    <h1 key={summary.nextPayoutAmount} className="material-blue text-center ff-Montserrat">
                        {`$${formatPrice(summary.nextPayoutAmount)}`}
                    </h1> : <></>
                    }
                </Card.Body>
                <Card.Footer>
                    <div style={{fontSize: "12px", textAlign: "center"}}>
                        This amount is not finalized until 15th of the following month.
                    </div>
                </Card.Footer>
            </Card>
        </section>
    );
}